// This file is used in both Node.js end browser envs.
// It has .mjs extension to make ESM syntax work in Node
import teal from '@material-ui/core/colors/teal.js';
import zIndices from '@material-ui/core/styles/zIndex.js';

import palette from './palette.mjs';
import lightThemePalette from './lightThemePalette.mjs';

export const themeVariables = { palette };

export const lightThemeVariables = {
  palette: {
    ...lightThemePalette,
    charts: {
      background: '#d5d9d9',
      gaugeArrow: 'black',
    },
  },
  status: {
    loginTextField: teal['600'],
    loginButton: lightThemePalette.primary.main,
    loginButtonHovered: lightThemePalette.primary.main,
    loginButtonLabel: '#000000',
    loginLinearProgress: teal.A700,
  },
};

export const darkThemeVariables = {
  ...themeVariables,
  palette: {
    ...themeVariables.palette,
    charts: {
      background: '#2a2e2e',
      gaugeArrow: 'white',
    },
  },
  status: {
    loginTextField: teal['400'],
    loginButton: palette.primary.main,
    loginButtonHovered: palette.primary.main,
    loginButtonLabel: '#ffffff',
    loginLinearProgress: teal.A400,
  },
};

// z-indices, reexported for exposition as CSS-vars
// see https://v4.mui.com/customization/z-index/ for details
export const zIndicesVariables = {
  zIndex: { ...zIndices.default },
};
